import { SingleSignOnUserDto, User } from '@/modules/api';

export class UserGuard {
  public static isUser(user: User | SingleSignOnUserDto | undefined | null): user is User {
    return !!user && 'id' in user;
  }

  public static isSingleSignOnUser(user: User | SingleSignOnUserDto | null | undefined): user is SingleSignOnUserDto {
    return !!user && !('id' in user) && 'accountId' in user;
  }
}
